<template>
    <div v-if="walletDetails" class="container">
        <div class="deposit-request-wrapper">
            <div class="mene-details information-modal-sec">
                <div class="menu-details-list">
                    <ul>
                        <li v-if="walletDetails.request_amount">
                            <div class="menu-details-heading">
                                <h4>Requested Amount</h4>
                            </div>
                            <div class="menu-details-heading">
                                <h4> <span>{{ walletDetails.request_amount }}</span></h4>
                            </div>
                        </li>

                        <li v-if="walletDetails.accepeted_amount">
                            <div class="menu-details-heading">
                                <h4>Accepted Amount</h4>
                            </div>
                            <div class="menu-details-heading">
                                <h4> <span class="profit-color border-0">{{ walletDetails.accepeted_amount }}</span></h4>
                            </div>
                        </li>

                        <li v-if="walletDetails.request_time">
                            <div class="menu-details-heading">
                                <h4>Request Date</h4>
                            </div>
                            <div class="menu-details-heading">
                                <h4> <span class="profit-color border-0">{{
                                    convertUTCDateToLocalDateHere(walletDetails.request_time) }}</span></h4>
                            </div>
                        </li>

                        <li v-if="walletDetails.action_time">
                            <div class="menu-details-heading">
                                <h4>Action on</h4>
                            </div>
                            <div class="menu-details-heading">
                                <h4> <span class="profit-color border-0">{{
                                    convertUTCDateToLocalDateHere(walletDetails.action_time) }}</span></h4>
                            </div>
                        </li>

                        <!-- <li>
                            <div class="menu-details-heading">
                                <h4>Transfer type</h4>
                            </div>
                            <div class="menu-details-heading">
                                <h4> <span class="profit-color border-0">Google Pay</span></h4>
                            </div>
                        </li> -->

                        <li v-if="walletDetails.reference_no">
                            <div class="menu-details-heading">
                                <h4>Reference No.</h4>
                            </div>
                            <div class="menu-details-heading">
                                <h4> <span class="profit-color border-0">{{ walletDetails.reference_no }}</span></h4>
                            </div>
                        </li>

                        <li v-if="walletDetails.remark">
                            <div class="menu-details-heading">
                                <h4>Remarks </h4>
                            </div>
                            <div class="menu-details-heading">
                                <h4> <span class="profit-color border-0">{{ walletDetails.remark }}</span></h4>
                            </div>
                        </li>



                    </ul>
                </div>
            </div>

            <!-- <div class="view-details">
                <a  id="view-details-show" class="">
                    <div class="view-heading view-con"> View details</div>
                    <div class="view-heading hide-con"> Hide details</div>
                </a>

                <div class="view-details-con">
                    <div class="team-con border-0">
                        <div class="team-list-sec">
                            <ul>
                                <li class="list-dost">By me </li>
                                <li class="team-list-wet ms-1 team-list-wid"><img loading="lazy" src="@/assets/images/payment-img.webp" alt="">
                                </li>
                            </ul>
                            <ul>
                                <li class="list-dost">By Admin </li>
                                <li class="team-list-wet ms-1 team-list-wid">Remarks :- Deposit Done</li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div> -->
            <div v-if="siteSettings && siteSettings?.business_type == 2" class="whatsapp-btn">
                <a :href="'//wa.me/'+siteSettings.social_link.whatsappno1" target="_blank" class="thm-but" 
                    v-if="siteSettings.social_link.whatsappno1">
                <span class="whatsapp-icon"><img loading="lazy" src="@/assets/images/whatsapp-btn-icon.webp"
                            alt="whatsapp-icon"></span> whatsapp</a>
            </div>

        </div>

    </div>
</template>
<script>

import moment from 'moment'
export default {
    name: "TransactionDetail",
    props: ['walletDetails'],
    methods: {
        convertUTCDateToLocalDateHere(timestamp) {
            return moment(timestamp).format('DD MMM YYYY hh:mm:ss A');
        }
    },
    computed: {
        siteSettings() {
            return this.$store.getters.siteSettings;
        },
        domainName() {
            return this.$store.getters.domainName;
        }
    },
}
</script>